import React from 'react';
import { motion } from 'framer-motion';
export function ValueStackSection() {
  return <section id="comprar" className="w-full py-10 md:py-16 px-4 bg-[#FDF6F0]" data-id="element-140">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-gradient-to-b from-[#F3E8F0] to-white border-2 border-brand-gold rounded-3xl p-5 md:p-10 shadow-[0_0_40px_rgba(201,154,130,0.2)] relative overflow-hidden" data-id="element-141">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-20 bg-brand-gold/10 blur-3xl" data-id="element-142" />

        <div className="space-y-4 mb-5 md:mb-8" data-id="element-143">
          <div className="flex justify-between items-center border-b border-[#E8D8E0] pb-4" data-id="element-144">
            <span className="text-lg md:text-xl text-brand-text-primary" data-id="element-145">
              Ebook CÓDIGO HORMONAL (60 páginas)
            </span>
            <span className="text-brand-text-muted line-through" data-id="element-146">$17.990</span>
          </div>

          <div className="flex justify-between items-center border-b border-[#E8D8E0] pb-4" data-id="element-147">
            <div className="flex items-center gap-3" data-id="element-148">
              <span className="text-lg md:text-xl text-brand-text-primary" data-id="element-149">
                BONO 1: La Cocina Biohacker
              </span>
              <span className="bg-brand-orange text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-150">
                GRATIS
              </span>
            </div>
            <span className="text-brand-text-muted line-through" data-id="element-151">$14.990</span>
          </div>

          <div className="flex justify-between items-center border-b border-[#E8D8E0] pb-4" data-id="element-152">
            <div className="flex items-center gap-3" data-id="element-153">
              <span className="text-lg md:text-xl text-brand-text-primary" data-id="element-154">
                BONO 2: Protocolo de Movimiento
              </span>
              <span className="bg-brand-orange text-white text-xs font-bold px-2 py-0.5 rounded" data-id="element-155">
                GRATIS
              </span>
            </div>
            <span className="text-brand-text-muted line-through" data-id="element-156">$9.990</span>
          </div>
        </div>

        <div className="border-t-4 border-brand-gold my-5 md:my-8" data-id="element-157" />

        <div className="text-center mb-6 md:mb-10" data-id="element-158">
          <p className="text-brand-text-muted text-lg mb-2" data-id="element-159">
            VALOR REAL DEL COMBO:{' '}
            <span className="line-through text-[#C94060] font-bold" data-id="element-160">
              $60.970
            </span>
          </p>
          <p className="text-3xl md:text-5xl font-extrabold text-brand-text-primary mb-2" data-id="element-161">
            TU INVERSIÓN HOY:
          </p>
          <p className="text-4xl md:text-6xl font-extrabold text-brand-orange" data-id="element-162">
            $17.990
          </p>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-163">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => window.open('https://ebookpromax.com/cart/46565326291102:1', '_blank')} className="neon-cta w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-xl md:text-2xl py-5 px-6 rounded-xl transition-all duration-300 uppercase text-center" data-id="element-164">
            <span className="cta-text-iridescent" data-id="element-165">
              SÍ, QUIERO EL CÓDIGO HORMONAL + MIS 2 BONOS GRATIS
            </span>
          </motion.button>

          <img src="https://cdn.magicpatterns.com/uploads/1tcAFFSyDP5pH1wBa7H2iV/WhatsApp_Image_2026-02-20_at_11.14.10.jpg" alt="Pago seguro - MercadoLíder Platinum" className="mt-2 w-full max-w-xs mx-auto rounded-xl opacity-90" data-id="element-166" />
        </div>
      </motion.div>
    </section>;
}